export default class BreadcrumbsFocus {
	start() {
		if ($('.ENABLE_BREADCRUMBS_FOCUS').length === 0) {
			return;
		}
		this.fixBreadcrumbsFocus();
	}

	fixBreadcrumbsFocus() {
		$(window).on('load', () => {
			$('#page-container .dcsbcm_divi_breadcrumb a').on('focus', function() {
				const breadcrumbColor = $(this).css('color');
				$(this).attr('style', `outline-color: ${breadcrumbColor} !important; outline-offset: 2px !important;`);
			});

			$('#page-container .dcsbcm_divi_breadcrumb a').on('focusout', function() {
				$(this).removeAttr('style');
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/breadcrumbs-focus.js